import { Extension } from '@lib/iab/iab-vast-model';

interface IExtension {
    type: string;
    _value: Element;
}

const createExtension = ($extension: IExtension): Extension => {
    const extension = new Extension();
    extension.type = $extension.type;
    extension.xmlElement = $extension._value;
    return extension;
};

export default createExtension;
